import { type SomeJSONSchema } from 'ajv/dist/types/json-schema';
import { setValidationProperties } from '../../utils/validation';
import { PropertyTypes } from './property-types';
import { type ValidationNumberType } from '@wix/ambassador-forms-v4-form/types';
import { ValidationMode } from '@wix/ambassador-forms-v1-validation-result/types';
import { NUMBER_VALIDATION_PROPERTIES } from '../schema-validation-properties';

export function mapToNumberSchemaProperty(
  numberField: ValidationNumberType,
  validationMode: ValidationMode,
): SomeJSONSchema & { type: 'number' } {
  return {
    type: PropertyTypes.NUMBER,
    maximum: Number.MAX_SAFE_INTEGER,
    minimum: Number.MIN_SAFE_INTEGER,
    ...resolveRestrictedValidationProperties(numberField, validationMode),
  };
}

function resolveRestrictedValidationProperties(
  numberField: ValidationNumberType,
  validationMode: ValidationMode,
) {
  if (validationMode !== ValidationMode.UNRESTRICTED_UPDATE) {
    return {
      ...setValidationProperties<number>(
        NUMBER_VALIDATION_PROPERTIES,
        numberField,
        {
          maximum: (value) =>
            Math.min(value ?? Number.MAX_SAFE_INTEGER, Number.MAX_SAFE_INTEGER),
          minimum: (value) =>
            Math.max(value ?? Number.MIN_SAFE_INTEGER, Number.MIN_SAFE_INTEGER),
          multipleOf: (value) => (value <= 0 ? 1 : value),
        },
      ),
    };
  }
  return {};
}
